import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../components-v2/Theme/theme';
import { opportunityChartTooltipChrome } from '../../helpers/opportunityChartTooltipChrome';

export const styleSheet = StyleSheet.create({
	tooltip: {
		...opportunityChartTooltipChrome,
	},
	tooltipLabel: {
		fontWeight: THEME.typography.fontWeights.bold,
		marginBottom: THEME.spacing.xs,
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
	},
	tooltipValue: {
		margin: 0,
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
	},
});
